import React from 'react';
import './CareerCompass.css';

const CareerCompass = () => {
  return (
    <section id="career-compass" className="career-compass-section">
      <div className="career-compass-container">
        <div className="section-header">
          <h2 className="section-title">Career Guidance Program</h2>
          <p className="section-subtitle">
            Bridging academic success with career excellence
          </p>
        </div>

        {/* Collaboration Header */}
        <div className="collaboration-header">
          <div className="logo-container tesla-logo">
            <img src="/logo.png" alt="Tesla's Academy Logo" />
            <p className="logo-label">Tesla's Academy</p>
          </div>
          
          <div className="collaboration-indicator">
            <span className="collaboration-text">In Collaboration With</span>
            <div className="collaboration-icon">✕</div>
          </div>
          
          <div className="logo-container career-compass-logo">
            <img src="/career-compass-logo.png" alt="Career Compass Logo" />
            <p className="logo-label">Career Compass</p>
          </div>
        </div>

        {/* Content Section */}
        <div className="career-compass-content">
          <div className="content-text">
            <h3 className="content-title">Empowering Your Future</h3>
            <p className="content-description">
              <strong>Career Compass</strong> is our comprehensive career guidance program designed to help students make informed decisions about their academic and professional future. Through personalized counseling, aptitude assessments, and industry exposure, we bridge the gap between classroom learning and real-world career success.
            </p>
            
            <div className="features-grid">
              <div className="feature-item">
                <span className="feature-icon">🎯</span>
                <div className="feature-content">
                  <h4>Career Assessment</h4>
                  <p>Scientific aptitude and interest analysis to identify the best career paths</p>
                </div>
              </div>
              
              <div className="feature-item">
                <span className="feature-icon">👨‍🏫</span>
                <div className="feature-content">
                  <h4>Expert Counseling</h4>
                  <p>One-on-one sessions with experienced career counselors and industry professionals</p>
                </div>
              </div>
              
              <div className="feature-item">
                <span className="feature-icon">📚</span>
                <div className="feature-content">
                  <h4>Stream Selection</h4>
                  <p>Guidance for choosing the right academic stream and entrance exam preparation</p>
                </div>
              </div>
              
              <div className="feature-item">
                <span className="feature-icon">🌐</span>
                <div className="feature-content">
                  <h4>Industry Exposure</h4>
                  <p>Workshops, seminars, and interactions with professionals from various fields</p>
                </div>
              </div>
              
              <div className="feature-item">
                <span className="feature-icon">🎓</span>
                <div className="feature-content">
                  <h4>College Planning</h4>
                  <p>Assistance with college selection, applications, and scholarship opportunities</p>
                </div>
              </div>
              
              <div className="feature-item">
                <span className="feature-icon">💼</span>
                <div className="feature-content">
                  <h4>Skill Development</h4>
                  <p>Workshops on soft skills, communication, and interview preparation</p>
                </div>
              </div>
            </div>

            <div className="cta-section">
              <p className="cta-text">
                Ready to discover your ideal career path? Explore Career Compass and take the first step towards a successful future.
              </p>
              <a 
                href="https://www.careercompass.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="career-compass-button"
              >
                Visit Career Compass
                <svg className="button-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="trust-section">
          <div className="trust-item">
            <span className="trust-number">500+</span>
            <span className="trust-label">Students Counseled</span>
          </div>
          <div className="trust-item">
            <span className="trust-number">50+</span>
            <span className="trust-label">Career Paths Explored</span>
          </div>
          <div className="trust-item">
            <span className="trust-number">95%</span>
            <span className="trust-label">Satisfaction Rate</span>
          </div>
          <div className="trust-item">
            <span className="trust-number">100%</span>
            <span className="trust-label">Personalized Guidance</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerCompass;
